import _actions_change_report from './_actions/change/report.js'
import _actions_open from './_actions/open.js'
import _getters_selections from './_getters/selections.js'
import _getters_item from './_getters/item.js'
import _getters_form_data from './_getters/form_data.js'
import _mutations_set from './_mutations/set.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        set: _mutations_set,
    },
    getters:{
        form_data: _getters_form_data,
        item: _getters_item,
        selections: _getters_selections,
    },
    actions:{
        open: _actions_open,
        change_report: _actions_change_report,
    },
}